module.exports = __webpack_public_path__ + "img/_weapon_ring_13.b0a81f8f.png";